import * as React from "react";
import * as styles from "./styles.css";
export var AdLabel = function (_a) {
    var children = _a.children;
    return React.createElement("div", { className: styles.adLabel }, children);
};



//////////////////
// WEBPACK FOOTER
// ./app/modules/search/components/ad/adLabel.tsx
// module id = a9ep
// module chunks = 2